$(document).ready(function($) { 
  
  if (!(typeof $.cookie('email') === 'undefined' && typeof $.cookie('token') === 'password')) {
    var cookie_email = Cookies.get('email');
    var cookie_password = Cookies.get('password');
    if(cookie_email && cookie_password){
      $('#email').val(cookie_email);
      $('#password').val(cookie_password);
    }
  }

  $(".login_sumbit_btn").on("click",function(e){
   // if (($("input[name*='remember']:checked").length) >=0) {
    if ($("input[name*='remember']").is(":checked")){
      var email = $('#email').val();
      var password = $('#password').val();  
      Cookies.set('email', email , { expires: 7 });
      Cookies.set('password', password , { expires: 7 });

    }else{
      Cookies.remove('email');
      Cookies.remove('password');
    }
  });


  //checkbox
 /* $('input[type=checkbox]#terms').click(function(){
    if ($('#terms').is(':checked')) {
      $('label.agreement_label, label.agreement_label a').css("color","black");
    }
  });
  $('body').on('click', '#customer-create .create-button', function() {
    if ($('input[type=checkbox]#terms').is(':checked')) {
      $(this).submit();
    }
    else {
      $('label.agreement_label, label.agreement_label a').css("color","#F9644A");
      return false;
    }
  });*/

//   $('input[type=checkbox]#updates').click(function(){
//     if ($('#updates').is(':checked')) {
//       $('label.email_label, label.email_label a').css("color","black");
//     }
//   });

//   $('body').on('click', '#customer-create .create-button', function() {
//     if ($('input[type=checkbox]#updates').is(':checked')) {
//       $(this).submit();
//     }
//     else {
//       $('label.email_label, label.email_label a').css("color","#F9644A");
//       return false;
//     }
//   });

  //   on hover change image
  $('.product-inner').on('mouseover',function(){
    $(this).find('.product-card-figure img:last-of-type').css('opacity',1);
  });
  $('.product-inner').on('mouseout',function(){
    $(this).find('.product-card-figure img:last-of-type').css('opacity',0);
  });

  $(window).scroll(function() {
    var myHeight = $('.ingredients-banner').outerHeight() + $('.home-slider-wrapper').outerHeight() + $('.featured-text-container').outerHeight() + $('.video-wrap').outerHeight() - 100;
    var myHeightReduced = myHeight - 150;
    var positiontop=$(document).scrollTop();
    if($(window).width() <= 576){
      if(positiontop > myHeight - 100){
        $('.question-popup1').addClass("showpopupmessage"); 
        setTimeout(function(){ $('.question-popup4').addClass("showpopupmessage");}, 500);
        setTimeout(function(){ $('.question-popup2').addClass("showpopupmessage");}, 1000);
      } else {
        if(positiontop < myHeightReduced - 100) {
          $('.question-popup1,.question-popup2,.question-popup3,.question-popup4,.question-popup5 ').removeClass("showpopupmessage");
        }
      }
    } else {
      if(positiontop > myHeight ){
        setTimeout(function(){ $('.question-popup1').addClass("showpopupmessage");}, 100); 
        setTimeout(function(){ $('.question-popup3').addClass("showpopupmessage");}, 500);
        setTimeout(function(){ $('.question-popup4').addClass("showpopupmessage");}, 800);
        setTimeout(function(){ $('.question-popup2').addClass("showpopupmessage");}, 1400);
        setTimeout(function(){ $('.question-popup5').addClass("showpopupmessage");}, 2000);
      } else {
        if(positiontop < myHeightReduced - 300 ) {
        	$('.question-popup1,.question-popup2,.question-popup3,.question-popup4,.question-popup5 ').removeClass("showpopupmessage");
        }
      }
    }
    
    /*setIntervalAndExecute(function () {
        setTimeout(function(){ $('.question-popup1').addClass("showpopupmessage");}, 100); 
        setTimeout(function(){ $('.question-popup3').addClass("showpopupmessage");}, 500);
        setTimeout(function(){ $('.question-popup4').addClass("showpopupmessage");}, 800);
        setTimeout(function(){ $('.question-popup2').addClass("showpopupmessage");}, 1400);
        setTimeout(function(){ $('.question-popup5').addClass("showpopupmessage");}, 2000);

      	setTimeout(function(){ $('.question-popup1').removeClass("showpopupmessage");}, 6100);
      	setTimeout(function(){ $('.question-popup3').removeClass("showpopupmessage");}, 6500);
        setTimeout(function(){ $('.question-popup4').removeClass("showpopupmessage");}, 6800);
        setTimeout(function(){ $('.question-popup2').removeClass("showpopupmessage");}, 7400);
        setTimeout(function(){ $('.question-popup5').removeClass("showpopupmessage");}, 7200);
      
    }, 11000);*/
  });
  
  function setIntervalAndExecute(fn, t) { fn(); return (setInterval(fn, t)); }
  
  
  function showCleanser(){
    $(".slide.first").addClass('active').css({"opacity":"1 !important"});
  }
  function showToner(){
    $('.slideshow--viewport').children('div.slide').eq(2).removeClass('active').css({"opacity":"0 !important"});
    $('.slideshow--viewport').children('div.slide').eq(0).removeClass('active').css({"opacity":"0 !important"});
    $('.slideshow--viewport').children('div.slide').eq(1).addClass('active').css({"opacity":"1 !important"});

  }
  function showHydrate(){
    $(".slide.last").addClass('active').css({"opacity":"1 !important"});
  }
  $('.clean-wrap ').click(function(){
    showCleanser();
  });
  $('.balance-wrap ').click(function(){
    showToner();
  });
  $('.hydrate-wrap ').click(function(){
    showHydrate();
  });

  $("marquee").hover(function () { 
    this.stop();
  }, function () {
    this.start();
  });
  $('.product-interactions').hide();

  //   on scroll show add to cart button
  $(".content-area.product-header ").addClass('addtocarthide');
  $(window).scroll(function(){
    var scroll = $(window).scrollTop();
    if (scroll >= 620){
      if($(window).width() <= 756){
        $(".content-area.product-header ").removeClass('addtocarthide').addClass('addtocartshowmobile');
      }
      else{
        $(".content-area.product-header ").removeClass('addtocarthide').addClass('addtocartshow');
      }

    }
    else{
      $(".content-area.product-header ").addClass('addtocarthide').removeClass('addtocartshow');
    }

  });

  //thumbnail for video
  var hasvideo= $(".product-main-image").attr('has_video');
  if(hasvideo === "true"){
    $(".product_detailed_image").addClass("product_video");
    $(".product-main-image.wrap ").hide();
  }

  $(".video-thumbnail").click(function () {
    if( $(".video-thumbnail").hasClass("thumbnail-border")){
      $(".product-main-image.wrap ").hide();
    }else{
      $(this).addClass("wrap active thumbnail-border");
      //       $(".product_detailed_image").addClass("product_video").css({ height: "100%" });      
      $(".video-wrapper").css("display", "block");
      $(".product-main-image.wrap ").hide();
      $(this).parent().find(".thumb").removeClass("active");

    }

  });
  $(".thumb").click(function () {
    $(".video-wrapper").hide();
    $(".product-main-image.wrap ").show();      	
    $(".video-thumbnail").removeClass("wrap thumbnail-border active");
  });


  function addtocartajax(ele,qty,variantid,handle){
    var item = {'quantity':qty,'id':variantid};	
    jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function(cart){
        var lineitems = cart.items;
        jQuery.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: item,
          beforeSend: function(){
            jQuery(ele).addClass('btn-purple');
          },success: function(cart){
            jQuery(ele).addClass('btn-purple');
          },
          complete: function(){
            jQuery(ele).addClass('btn-purple');
            jQuery(ele).text('Added');
            updatesidebarcart();
            setTimeout(function(){
              jQuery(ele).text('Add to Cart');
              jQuery(ele).removeClass('btn-purple');
              //location.reload(); 
            }, 1500);
            $('body').find('.cart-mini').addClass("cart-mini-open");
            $('.item-count').attr('data-cart-mini-count', cart.item_count);
          },
          error :function( jqXhr ) {
            //outof stock or higher stock added in cart handle
            if( jqXhr.status === 422 ) {
              var response = jqXhr.responseText;
              response = jQuery.parseJSON(response);
              var message = response.message;
              var description = response.description;
              alert(message+' : '+description);
            }
          }
        });
      }
    });
  }
  
  function addtocartajaxwithoutbuttons(ele,qty,variantid,handle){
    var item = {'quantity':qty,'id':variantid};	
    jQuery.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: item,
        beforeSend: function(){
          jQuery(ele).addClass('btn-purple');
        },success: function(cart){
          jQuery(ele).addClass('btn-purple');
        },
        complete: function(){
          jQuery(ele).addClass('btn-purple');
          jQuery(ele).text('Added');
          updatesidebarcartwithoutbuttons();
          setTimeout(function(){
            jQuery(ele).text('Add to Cart');
            jQuery(ele).removeClass('btn-purple');
            //location.reload(); 
          }, 1500);
          $('body').find('.cart-mini').addClass("cart-mini-open");
        //   $('.item-count').attr('data-cart-mini-count', cart.item_count);
        },
        error :function( jqXhr ) {
          //outof stock or higher stock added in cart handle
          if( jqXhr.status === 422 ) {
            var response = jqXhr.responseText;
            response = jQuery.parseJSON(response);
            var message = response.message;
            var description = response.description;
            alert(message+' : '+description);
          }
        }
      });
  }
  
  $('.recommend-add-to-cart, .addtocart-ajax').click(function() {
    var variant_id=$(this).attr('data-product-variant-id');
    var prod_handle=$(this).attr('data-prod-handle');
    Shopify.getCart(cart => {
      var itemId = this.getAttribute('data-product-variant-id')
      var currentItemQuantity = cart.items.find(item => item.id == itemId)?.quantity || 0;
      var maxQuantity = window.settings.maximumItemQuantityPerOrder.maximumItemQuantity 
      console.log(this.getAttribute('max-quantity-items'))
      if (this.getAttribute('max-quantity-items') !== null){
        maxQuantity = this.getAttribute('max-quantity-items')
      }

      if ((currentItemQuantity + 1) > maxQuantity) {
        document.getElementById('cart_maximum_item_popup').classList.add('visible');
        document.getElementById('cart_maximum_item_popup').querySelector('.copy span').innerHTML = maxQuantity
      } else {
        addtocartajaxwithoutbuttons(this,1,variant_id,prod_handle);
      }
    })
    
  });
/*
  $(window).scroll(function(){
    var scroll = $(window).scrollTop();
    if (scroll >= 520){
      if($(window).width() <= 720){
        $("#shopify-section-static-product, .section-product").removeClass('why_we_love');
      }
      else{
        $("#shopify-section-static-product, .section-product").addClass('why_we_love');
      }

    }
    else{
      $("#shopify-section-static-product, .section-product").removeClass('why_we_love');
    }
  });
*/
  $(window).scroll(function(){
    var scroll = $(window).scrollTop();
    if (scroll >= 550){
      $('.main-header-wrap').addClass('header_border');

    }
    else{
      $('.main-header-wrap').removeClass('header_border');
    }
  });



  $(window).scroll(function(){
    var scroll = $(window).scrollTop();
    if (scroll >= 460){
      if($(window).width() <= 770){
        $('.thumb').removeClass('new_thumb_border_color');
      }
      else{
        $('.thumb').addClass('new_thumb_border_color');
      }

    }
    else{
      $('.thumb').removeClass('new_thumb_border_color');
    }
  });


  function updatesidebarcartwithoutbuttons(){
    console.log('updatesidebarcartwithoutbuttons')
    return;
    jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function(cart){
        var lineitems = cart.items;
        var subtotal = cart.items_subtotal_price/100;
        var total = cart.total_price/100;
        var lineitemshtml = '';
        var totalprice = '';
        var cartlinehtml ='';
        var mobilelinehtml = '';
        var totalProductCount = 0;
        $.each(lineitems, function(i, item) {
          var purl = lineitems[i].url;
          var ptitle = lineitems[i].product_title;
          var pname = ptitle;
          var pfirstname = pname.split(' ')[0];
          var plastname = pname.substring(pfirstname.length).trim();
          var a = pname.lastIndexOf(' - '); // last occurence of space
          var pfirstname = pname.substring(0, a);
          var plastname = pname.substring(a+1).split('-').join(' ');;
          var pdesc = lineitems[i].product_description;
          var pprice = (lineitems[i].line_price/100).toFixed(2);
          var product_price = (lineitems[i].final_price/100).toFixed(2);
          var image = lineitems[i].image;
          var url = lineitems[i].url;
          var pqty = lineitems[i].quantity;
          totalProductCount = parseInt(totalProductCount,10) + parseInt(pqty,10);
          var uvid = lineitems[i].key; //unique variant id with properties
          var vid = lineitems[i].variant_id;
          var key= lineitems[i].key;
          var expected_shipping = ''
          if (lineitems[i].handle == 'solar-mate' || lineitems[i].handle == 'plus-one'){
            expected_shipping = "<span class='item-property-value scto-medium mt-0 item-subtitle'>*expected to ship 6/13</span>"
          }
          var linehtml = '<div class="cart-mini-item" data-cart-mini-item="'+key+'" >\
            <div class="cart-mini-item-row 1a">\
              <div class="cart-mini-item-column cart-mini-item-column-image">\
              <a href="'+url+'"><figure class="cart-mini-item-image"> <img src="'+image+'"></figure></a>\
              </div> <div class="cart-mini-item-column cart-mini-item-column-details">\
              <span class="cart-mini-item-title">\
              <a href="'+purl+'">'+plastname+'</a>\
              </span>' + expected_shipping + '\
              <span class="cart-mini-item-quantity">Qty: '+pqty+'</span>\
         	 <div class="cart-mini-item-details-footer">\
            <div class="cart-mini-item-prices">\
              <span class="cart-mini-item-final-price cart-mini-item-price money">$'+pprice+'</span>\
            </div></div></div> </div> </div>'
            lineitemshtml += linehtml;


          var carthtml ='<tr class="table-row cart-item" data-cart-item="" data-cart-item-key="'+key+'">\
              <td class="cart-item-column product-image ">\
              <div class="image-wrap">\
              	<a class="image" href=" '+ purl + '"><img src="'+ image +'"></a></div>\
              </td>\
              <td class="cart-item-column product-item">\
              <a href="'+ purl + '" title="">\
				<div class="wrap"><span class="label title"><span class="cart_product_first_title">'+ plastname +'</span>\
             	 <div class="item-properties">\
              </div></div>\
				</a>\
              </td>\
              <td class="cart-item-column cart-item-column-price price">\
              <span class="cart-item-label-mobile">Price</span>\
              	<div class="cart-item-column-contents">\
              		<span class="cart-item-final-price money">$'+product_price+'</span>\
              	</div>\
              </td>\
              <td class="cart-item-column cart-item-column-quantity quantity">\
             		 <span class="cart-item-label-mobile">Quantity: '+pqty+'</span>\
              </td>\
              <td class="cart-item-column cart-item-column-total total last">\
                <span class="cart-item-label-mobile">Total</span>\
                	<div class="cart-item-column-contents"><div class="display">\
                <span class="cart-item-final-price money">$'+pprice+'</span>\
              		</div>\
              	</div>\
              </td>\
              </tr>'
              cartlinehtml += carthtml;

              var mobilecartlinehtml = '<div class="mobile_cart_table_content_wrap"><div class="mobile_cart_table_items">\
              	<div class="image-wrap"> <a class="image" href="'+ purl + '">\
              		<img src="'+ image +'"></a>\
              	</div><div class="cart_table_left_items">\
              		<span class="label title"><span class="cart_product_first_title"><a href="'+ purl + '" title="">'+ plastname +' </a></span>\
              			<span class="cart-item-label-mobile">Quantity: '+pqty+'</span>\
             		 <div class="cart-item-column-contents"><s class="cart-item-original-price money"></s>\
             	 <span class="cart-item-final-price money">$'+pprice+'</span></div></div></div></div>'
              mobilelinehtml += mobilecartlinehtml
        });

        var footercarthtml = '<div class="cart-mini-subtotal">\
              <span class="cart-mini-subtotal-heading">Subtotal</span>\
              <span class="cart-mini-subtotal-value money"></span>\
            </div>\
            <div class="cart-mini-actions">\
              <a class="cart-mini-actions-checkout action-button submit-button" href="/checkout"><span>Checkout</span></a>\
              <a class="cart-mini-actions-cart action-button desaturated" href="/cart">View Cart</a>\
            </div>'
        $('[data-cart-mini-footer').html(footercarthtml);
        $('.mobile_static_cart_wrap').html(mobilelinehtml);
        $('.cart-mini-content.cart-mini-items').html(lineitemshtml);
        $('.cart-table.table.cart-table_wrapper tbody').html(cartlinehtml);
        $('.cart-mini-subtotal-value.money').html('$'+total);
        $('.cart_message_price_wrap').find('.money').html('$'+total);
        $('.item-count').html(totalProductCount);
		$('.item-count').attr('data-cart-mini-count', cart.item_count);
      }

    });

  }
  
  function updatesidebarcart(){
    console.log('updatesidebarcart')
    return;
    jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function(cart){
        var lineitems = cart.items;
        var subtotal = cart.items_subtotal_price/100;
        var total = cart.total_price/100;
        var lineitemshtml = '';
        var totalprice = '';
        var cartlinehtml ='';
        var mobilelinehtml ='';
        var totalProductCount = 0;
        $.each(lineitems, function(i, item) {
          var purl = lineitems[i].url;
          var ptitle = lineitems[i].product_title;
          var pname = ptitle;
          var pfirstname = pname.split(' ')[0];
          var plastname = pname.substring(pfirstname.length).trim();
          var a = pname.lastIndexOf(' - '); // last occurence of space
          var pfirstname = pname.substring(0, a);
          var plastname = pname.substring(a+1).split('-').join(' ');;
          var pdesc = lineitems[i].product_description;
          var pprice = (lineitems[i].line_price/100).toFixed(2);
          var product_price = (lineitems[i].final_price/100).toFixed(2);
          var image = lineitems[i].image;
          var pqty = lineitems[i].quantity;
          totalProductCount = parseInt(totalProductCount,10) + parseInt(pqty,10);
          var uvid = lineitems[i].key; //unique variant id with properties
          var vid = lineitems[i].variant_id;
          var key= lineitems[i].key;
          var linehtml = '<div class="cart-mini-item" data-cart-mini-item="'+key+'" >\
            <div class="cart-mini-item-row">\
              <div class="cart-mini-item-column cart-mini-item-column-image">\
                <figure class="cart-mini-item-image"> <img src="'+image+'"></figure>\
              </div> <div class="cart-mini-item-column cart-mini-item-column-details">\
              <span class="cart-mini-item-title">\
              <a href="'+purl+'">'+pfirstname+'<h3 class="mini-cart-product-last-title">'+plastname+'</h3></a>\
              </span><span class="cart-mini-item-quantity">\
				<span class="cart-mini-item-quantity">Qty: '+pqty+'</span>\
              </span>\
         	 <div class="cart-mini-item-details-footer">\
            <div class="cart-mini-item-prices">\
              <span class="cart-mini-item-final-price cart-mini-item-price money">$'+pprice+'</span>\
            </div></div></div> </div> </div>'
            
           
            /*
            <div class="mini_cart_product-count">\
              <div class="plusminus-btn">\
              <div class="cart_product-count product-qty-'+vid+'" data-id="'+vid+'" data-key="'+vid+'" variantid="'+vid+'">\
              <input type="button" value="-" class="qtyminus mini_cart_minus updateproduct" field="quantity_'+vid+'" />\
              <input class="cart-item-quantity field qty" type="text" autocomplete="off" name="quantity_'+vid+'" id="quantity_'+vid+'" value="'+pqty+'">\
              <input type="button" value="+" class="qtyplus mini_cart__plus updateproduct" field="quantity_'+vid+'" />\
              </div> </div> </div>
            <div class="plusminus-btn">
              <div class="cart_product-count product-qty-32732419195012" data-id="32732419195012" data-key="32732419195012:18e1cc7afb0fe936665a131c859445aa" variantid="32732419195012">
                <input type="button" value="-" class="qtyminus cart-table_minus updateproduct" field="quantity_32732419195012">
                <input class="cart-item-quantity field qty" type="text" autocomplete="off" name="quantity_32732419195012" id="quantity_32732419195012" value="4" data-cart-item-quantity="">
                <input type="button" value="+" class="qtyplus cart-table_plus updateproduct" field="quantity_32732419195012">
              </div>
            </div>
      		*/
            lineitemshtml += linehtml;


          var carthtml ='<tr class="table-row cart-item" data-cart-item="" data-cart-item-key="'+key+'">\
              <td class="cart-item-column product-image ">\
              <div class="image-wrap">\
              	<a class="image" href=" '+ purl + '"><img src="'+ image +'"></a></div>\
              </td>\
              <td class="cart-item-column product-item">\
              <div class="wrap"><span class="label title"><span class="cart_product_first_title"><a href="'+ purl + '" title="">'+ plastname +' </a></span>\
             	 <div class="item-properties">\
              </div></div>\
              </td>\
              <td class="cart-item-column cart-item-column-price price">\
              <span class="cart-item-label-mobile">Price</span>\
              	<div class="cart-item-column-contents">\
              		<span class="cart-item-final-price money">$'+product_price+'</span>\
              	</div>\
              </td>\
              <td class="cart-item-column cart-item-column-quantity quantity">\
             		 <span class="cart-item-label-mobile"> Quantity</span>\
              	<div class="plusminus-btn">\
             	 <div class="cart_product-count product-qty-'+vid+'" data-id="'+vid+'"  variantid="'+vid+'">\
              		  <input type="button" value="-" class="qtyminus cart-table_minus updateproduct" field="quantity_'+vid+'">\
              		  <input class="cart-item-quantity field qty" autocomplete="off" name="quantity_'+vid+'" id="quantity_'+vid+'" value="'+pqty+'" data-cart-item-quantity="">\
             		  <input type="button" value="+" class="qtyplus cart-table_plus updateproduct" field="quantity_'+vid+'">\
             		 </div>\
						<a class="cart-item-remove" href="/cart/change/'+vid+'?line=1&amp;quantity=0" data-cart-action="remove">Remove</a>\
             		 </div>\
              </td>\
              <td class="cart-item-column cart-item-column-total total last">\
                <span class="cart-item-label-mobile">Total</span>\
                	<div class="cart-item-column-contents"><div class="display">\
                <span class="cart-item-final-price money">$'+pprice+'</span>\
              		</div>\
              	</div>\
              </td>\
              </tr>'
              cartlinehtml += carthtml;

              var mobilecartlinehtml = '<div class="mobile_cart_table_content_wrap"><div class="mobile_cart_table_items">\
              	<div class="image-wrap"> <a class="image" href="'+ purl + '">\
              		<img src="'+ image +'"></a>\
              	</div><div class="cart_table_left_items">\
              		<span class="label title"><span class="cart_product_first_title"><a href="'+ purl + '" title="">'+ plastname +' </a></span>\
              		<div class="plusminus-btn">\
                 	 <div class="cart_product-count product-qty-'+vid+'" data-id="'+vid+'"  variantid="'+vid+'">\
                 	 <input type="button" value="-" class="qtyminus cart-table_minus updateproduct" field="quantity_'+vid+'">\
                  	<input class="cart-item-quantity field qty" autocomplete="off" name="quantity_'+vid+'" id="quantity_'+vid+'" value="'+pqty+'" data-cart-item-quantity="">\
                  	<input type="button" value="+" class="qtyplus cart-table_plus updateproduct" field="quantity_'+vid+'">\
                  </div></div>\
             		 <div class="cart-item-column-contents"><s class="cart-item-original-price money"></s>\
             	 <span class="cart-item-final-price money">$'+pprice+'</span></div></div>\
                <a class="cart-item-remove" href="/cart/change/'+vid+'?line=1&amp;quantity=0" data-cart-action="remove">Remove</a>\
                </div></div>'
              mobilelinehtml += mobilecartlinehtml
        });
        $('.mobile_static_cart_wrap').html(mobilelinehtml);
        $('.cart-mini-content.cart-mini-items').html(lineitemshtml);
        $('.cart-table.table.cart-table_wrapper tbody').html(cartlinehtml);
        $('.cart-mini-subtotal-value.money').html('$'+total);
        $('.cart_message_price_wrap').find('.money').html('$'+total);
        $('.item-count').html(totalProductCount);
        $('.item-count').attr('data-cart-mini-count', cart.item_count);

        $('.free-shipping-msg-wrapper__container').show()
        var freeshippingprice = 39;
        if(total < freeshippingprice && total > 0) {
          var neededamount = (freeshippingprice - total).toFixed(2);
          $('.free-shipping-msg-wrapper').text('You are $'+neededamount+' away from free shipping');
        }
        if (total >= freeshippingprice ) {
          $('.free-shipping-msg-wrapper').text('Congrats! You have free shipping');
      	} 
        /* Free shipping international 
        var freeshippingpriceint = 100;
        if(total < freeshippingpriceint && total > 0) {
          var neededamountinternational = (freeshippingpriceint - total).toFixed(2);
          $('.free-shipping-msg-wrapper__international').text('You are $'+neededamountinternational+' away from 50% off international shipping');
        }
        if (total >= freeshippingpriceint ) {
          $('.free-shipping-msg-wrapper__international').text('Congrats! You have 50% off international shipping');
      	} 
        */
      }

    });
  }
  
//  
  const open = window.XMLHttpRequest.prototype.open;

  function openCalculator() {
    this.addEventListener("load", function () {
      if (
        [
          "/cart/add.js",
          "/cart/update.js",
          "/cart/change.js",
          "/cart/clear.js",
        ].includes(this._url)
      ) {
        //calculateFreeShipping(); 
        setTotalItemQty();
        //calculateFreeShipping(this.response);
      }
    });
    return open.apply(this, arguments);
  }

  window.XMLHttpRequest.prototype.open = openCalculator;

  function calculateFreeShipping() {
    jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function(cart){
        var total = cart.total_price/100;
        var freeshippingprice = 39;
        $('.free-shipping-msg-wrapper__container').show()
        if(total < freeshippingprice ) {
          var neededamount = (freeshippingprice - total).toFixed(2);
            $('.free-shipping-msg-wrapper').text('You are $'+neededamount+' away from Free Shipping!');
        } 
        if (total >= freeshippingprice ) {
            $('.free-shipping-msg-wrapper').text('Congrats! You have free shipping!');
        }

        /* Free shipping international 
        var freeshippingpriceinternational = 100;
        if(total < freeshippingpriceinternational ) {
          var neededamountinternational = (freeshippingpriceinternational - total).toFixed(2);
            $('.free-shipping-msg-wrapper__international').text('You are $'+neededamountinternational+' away from 50% off international shipping');
        } 
        if (total >= freeshippingpriceinternational ) {
            $('.free-shipping-msg-wrapper__international').text('Congrats! You have 50% off international shipping');
        }
        */

       }
   	});
  }
          
  function setTotalItemQty() {
    jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function(cart){
		$('.item-count').attr('data-cart-mini-count', cart.item_count);
      }
   	});
  }

//
                          
  function updateproduct(variantid,quantity){
    var item = '{"updates":{"'+variantid+'":'+quantity+'}}';
    item = JSON.parse(item);
    jQuery.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function(cart){
        jQuery.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          type: 'post',
          data: item,
          success:function(cart){
            updatesidebarcart();
            checkGWP(cart, () => location.reload(), true);
          },
          error :function( jqXhr ) {
            console.log(jqXhr);
            console.log(jqXhr.responseText);
          }
        });
      }
    });
  }
  
  // This button will increment the value
  $(document).on('click','.cart-table_plus.qtyplus, .cart-table_plus',function(e){
    // Stop acting like a button
    e.preventDefault();
    console.log('plus');
    // Get the field name
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    var new_qty = 1;
    if (!isNaN(currentVal)) {
      // Increment
      var new_val = currentVal + 1;
      new_qty = new_val;
    }

    if($(this).hasClass('updateproduct')){
      var varient_id = $(this).parent().attr('variantid');
      if (window.settings.maximumItemQuantityPerOrder.enabled) {
        if (new_qty >= window.settings.maximumItemQuantityPerOrder.maximumItemQuantity) {
          $(this).attr('disabled', 'disabled');
        } else {
          $(this).removeAttr('disabled');
        }

        if (new_qty > window.settings.maximumItemQuantityPerOrder.maximumItemQuantity) {
          document.getElementById('cart_maximum_item_popup').classList.add('visible');
        } else {
          if (!isNaN(currentVal)) {
            $('input[id='+fieldName+']').val(new_val);
            $('input[id='+fieldName+']').attr('value', new_val);
          } else {
            $('input[id='+fieldName+']').val(1);
            $('input[id='+fieldName+']').attr('value', 1);
          }
          updateproduct(varient_id, new_qty);
        }
      } else {
        if (!isNaN(currentVal)) {
          $('input[id='+fieldName+']').val(new_val);
          $('input[id='+fieldName+']').attr('value', new_val);
        } else {
          $('input[id='+fieldName+']').val(1);
          $('input[id='+fieldName+']').attr('value', 1);
        }
        updateproduct(varient_id, new_qty);
      }
    }
  });
  // This button will decrement the value till 0
  $(document).on('click',' .cart-table_minus.qtyminus, .cart-table_minus',function(e){
    //   $(".qtyminus").click(function(e) {
    console.log("minus");
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    var new_qty = 1;
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      var new_val = currentVal - 1;
      $('input[id='+fieldName+']').val(new_val);
      $('input[id='+fieldName+']').attr('value',new_val);
      new_qty = new_val;
      console.log(new_qty);
    } else {
      // Otherwise put a 0 there
      $('input[id='+fieldName+']').val(0);
    }
    if($(this).hasClass('updateproduct')){
      if(currentVal==1){new_qty=0;} //to remove product from minicart
      var variantid = $(this).parent().attr('variantid');
      updateproduct(variantid,new_qty);
    }
  });


  /*$('.qtyplus.mini_cart_plus').click(function(e){
    console.log("clicked");

  });*/
  
  $('.see-more').click(function(e) {
      console.log('clicked here');
      e.preventDefault();
      var anchor_goto = $(this).attr('href');
    console.log(anchor_goto);
      $('html,body').animate({scrollTop: $(anchor_goto).offset().top},'slow');console.log('clicked here 123');
	});
   
    //jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.quantity input');
    jQuery('.qty-wrapper').each(function() {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity__plus'),
        btnDown = spinner.find('.quantity__minus'),
        min = input.attr('min'),
        max = 100;
      

      btnUp.click(function(e) {
        e.preventDefault();
        var oldValue = parseFloat(input.val());
        console.log(input.val());
        var newVal = oldValue + 1;
        console.log(oldValue+', '+newVal);
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function(e) {
        e.preventDefault();
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }console.log(oldValue+', '+newVal);
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });
  
  //remove desktop form for mobile devices
  if (window.matchMedia("(max-width: 576px)").matches){ 
    $( ".desktop .product-form" ).remove();
    $( ".desktop .single-option-selector" ).remove();
  } else {
    $( ".mobile .single-option-selector" ).remove();
  }
  
  $('.morethanskin-resources a, .morethanskin-betterhelp a, .morethanskin-support a').click(function(e) {
    var newwindow = window.open($(this).prop('href'), '', 'height=800,width=800');
    if (window.focus) {
      newwindow.focus();
    }
    return false;
  });
  
});

async function loadNames() {
  const response = await fetch('/browsing_context_suggestions.json');
  const obj = await response.json();
  if (obj.detected_values.country.handle == 'US'){
    setTimeout(() => {
    $('.free-shipping-msg-wrapper').show();
    $('.free-shipping-msg-wrapper__international').hide();
    }, 500)
  } else{
     setTimeout(() => {
    $('.free-shipping-msg-wrapper__international').show();
   
    }, 500)
  }
}
loadNames()

/* ----------------------- */
/* Before / After section */
jQuery(document).ready(function ($) {
  $(".before-after__container-blocks").slick({
      slidesToShow: 2.6,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.6,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          autoplay: 1500
        }
      }
  ]
  });
});
/* ----------------------- */
